<div class="reference-point-input-container">
  <div style="flex: 1;">
    <input #inputRef type="text" class="reference-point-input" [ngClass]="{'error-border': showError}"
      placeholder="Buscar Ubicación"
      [(ngModel)]="locationIdentifier"
      (input)="onSearchInput()"
      (keyup.enter)="searchLocation()"
      (focus)="onInputFocus()"
      (blur)="onInputNoFocus()"
      [disabled]="isSearchDisabled"
      autocomplete="off">

    <div class="directions-list" [class.directions-list--above]="dropdownAbove" *ngIf="inputFocused && showSuggestions && locationSuggestions.length > 0">
      <div class="directions-item" *ngFor="let suggestion of locationSuggestions" (click)="selectSuggestion(suggestion)">
        <div class="directions-data">
          <div class="directions-name">{{ suggestion.identifier }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
